import { sendPost } from '../http.js'
const api = {
	'activeList': '/user/user/active/list',
    'activeAdd': '/user/user/active/add',
    'productSelect': '/user/user/product/select',
    'activeDel': '/user/user/active/del',
    'activeSurplus': '/user/user/active/surplus',
    'getBindedDyListAPI': '/operate/get_dycode_list', // 获取讲师绑定抖音号列表
    'updateDyAccountAPI': '/operate/store_aweme_id', // 更新讲师抖音号账号
    'getDyWorksListAPI': '/operate/get_video_list', // 获取讲师近30天的作品列表
    'mountMiniVideoAPI': '/operate/bind_product' // 自主挂载存量视频绑定锚点
}
export default {
	activeList(params) {
	    return sendPost(api.activeList, params)
	},
    activeAdd(params) {
        return sendPost(api.activeAdd, params)
    },
    productSelect(params) {
        return sendPost(api.productSelect, params)
    },
    activeDel(params) {
        return sendPost(api.activeDel, params)
    },
    activeSurplus(params) {
        return sendPost(api.activeSurplus, params)
    },
    getBindedDyListAPI(params) {
        return sendPost(api.getBindedDyListAPI, params)
    },
    updateDyAccountAPI(params) {
        return sendPost(api.updateDyAccountAPI, params)
    },
    getDyWorksListAPI(params) {
        return sendPost(api.getDyWorksListAPI, params, 'post', {}, {backAllErrObj:true})
    },
    mountMiniVideoAPI(params) {
        return sendPost(api.mountMiniVideoAPI, params)
    }
}